import { Injectable } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { GridApi } from "ag-grid-community";
import moment from "moment";
import { BehaviorSubject, EMPTY, observable, Observable, Subject } from "rxjs";
import { ApiService } from "./api.service";
import { HelperService } from "./helper.service";
import { isNull } from "lodash";

declare var window: any;

@Injectable({
  providedIn: "root",
})
export class FilterService {
  //New logic implementing for the intractive chart
  intractiveFilter = new Subject<any>();

  filterQuery = new Subject<any>();
  lastRefreshedDate = new Subject<any>();
  hasPhiHiddenToggle = false;
  phiAccessConsentFlag = 'N';
  phiEventTrigger = new Subject<any>();
  userMenuSideBar = new Subject<any>();
  inputValueOfPagenation = new Subject<any>();
  dataPartnerRefreshingGrid = new Subject<any>();
  individualSelectedData:any;
  badges: any[] = [];
  badgeChanges = new Subject<any>();
  refreshAlert = new BehaviorSubject(false)
  isDataLoaded: boolean = false
  brandKeyForLastRefreshed = new Subject<any>();
  kpiBreakDownSelectedType = new Subject<any>();
  flagUpdateOnscreen = new Subject<any>();
  topNavLocation = new Subject<any>();
  treeMapSingleClickTrigger = new Subject<any>();
  intractiveClickTrigger = new Subject<any>();

  selectAllAsNull: any = [];
  previousSelectedItems: any[] = [];
  previousSingleSelectedItems: any[] = [];
  previousQuarterFromSelectedItems: any[] = [];
  previousQuarterToSelectedItems: any[] = [];

  backupAllSingleAndMulti: any = [];

  previousTimeCycleFromSelectedItem = {};
  previousTimeCycleToSelectedItem = {};

  previousToDateForTimeCycle: any[] = []
  
  patientStatusJouneryArray:any = {};
  allLocationData:any = {};
  
  previousToDateForMonth: any
  previousToDateForYear: any
  previousToDateForDate: any
  // showby variables
  showByUOM = new Subject<any>();
  showbyfilterQuery = new Subject<any>();
  showByChangeFilter = new Subject<any>();
  showByInGrid: any;
  showByHeader: any;
  showByAPI: boolean = false

  filterCheck = false;
  selectedBrandName:any;
  
  brandBasedTimeCycle = new BehaviorSubject<any>(null);
  brandBasedTime = false
  
  navigateToPageBrandbased = new Subject<any>();
  previousBrandKey: any;
  isBrandLevelJson = false;

  filterIcon = false;
  alertIcon = false;
  refreshData = false;
  kpi2LoadingIssue: any;
  headerTop: any;
  filterConfig = new Subject<any>();
  columnClickedOnGrid = new Subject<any>();
  filterQueryForAnnotation: any;
  brandCarry = false;
  dragDate: any = []
  yearDefault: any
  yearToDefault: any
  desectedValue: any;
  allDefaultDate:any = {};
  private hasMethodExecuted = false;
  defaultDateSelection:any;
  
  selectedItem: any = {
    'single': {},
    'multi': {},
    'date': {},
    'quarter': {},
    'quarterFrom': {},
    'quarterTo': {},
    'timeCycle': {},
    'formly_date': {},
    'formly_yearly_selection': {}
  }

  allOptionData: any = {
    'single': {},
    'multi': {},
    'date': {},
    'quarter': {},
    'quarterFrom': {},
    'quarterTo': {},
    'timeCycle': {},
    'formly_date': {},
    'formly_yearly_selection': {}
  }
  findFilter: any

  hoverBackground = false

  brandSelectWithBackNavigation = true;

  testing: any = {}
  previousSelectedDate: any = {};
  filterValues: any;
  baseQuery: any;
  report_type: any;
  defaultReport_type: any
  previousModel: any = {};
  previousFilterModel: any = {};
  isDataLoadedCard = false
  filterFields: any[] = [];
  source_key: any = ''
  navHeaderData: any = null
  logoChange = new Subject<any>();
  duplicateParameter: any = {};
  selectAllNullColumn:any = {};
  sortingDataPatientAndPrescriber: any

  globalFilterFields: any[] = [];
  model: any = {}
  selectedFilterValue: any;
  isGlobal = false
  isGlobalSub = new Subject<any>();
  chroplethMapSelection = new Subject<any>();

  patienListAlertsSince: any
  alertsIconfromPatientCard = false

  rowData: any[] = [];
  sliderValue = 1
  patientListApi: any
  locationDataLoaded = false;
  refreshTheDashboard = false;

  prName = ''
  public gridApi!: GridApi
  timeCycleCount: any

  // toolTipDragEvent = new Subject<any>();

  formReset = new Subject<any>();
  timeCycleDate = new Subject<any>();
  resetBadges = new Subject<any>();
  resetBadgesCheck = new Subject<any>();
  isLinkColSelectConfig: any;

  hoverDataRefresh = new Subject<any>(); //
  refreshAlertDelete = new Subject<any>(); //
  refreshStatusChangeData = new Subject<any>();
  editingDataGrid = new Subject<any>();
  refreshAlertDeleteDups = new Subject<any>(); //

  badgeCheck = false;
  timeCycleDateRange: any;

  filterReset: any = {};
  toolTipAlertData: any

  startDate = new Date
  endDate = new Date

  selectedDate: any = {
    start: this.startDate,
    end: this.endDate,
  };

  dateRange: any = new FormGroup({
    start: new FormControl(this.selectedDate.start),
    end: new FormControl(this.selectedDate.end),
  });

  selectedDateRange: any

  hideToolTipe = false
  hideTools = new Subject<any>();
  selectedPageGrid = new Subject<any>();
  public hiraricalGridApi!: GridApi | any;
  allGroupsClosed = false;
  recdetailGrid = false;
  checkArray: any[] = []
  selectedBrand: any;
  selectedBrandCount: any;

  selectedColumn: any[] = []

  timecycleData: any[] = [];
  selectedType: any
  kpiDateRange: any
  dateRangeCheck = false;
  dateRangeFilterCheck = false;
  firstModuleKey: any;
  autoHeightAdjust = false;

  locationPresId: any;
  // Selected Filters
  navDataforFilters = new Subject<any>();
  emitFilterChange = new Subject<any>();
  currentData = this.emitFilterChange.asObservable();
  employKey: any

  widthForSideBar: any;
  refreshfromAccodin = false
  dataRefreshinTooltip = new Subject<any>();

  singlePage = false;
  showLessAndMore = new Subject<any>();
  isPHIFunc = new Subject<any>();
  onQuickFilter = new Subject<any>();
  onPageSizeChange = new Subject<any>();
  sortByChanged = new Subject<any>();
  triggerSort = new Subject<any>();
  changeDisplays = new Subject<any>();
  movingAverage = new Subject<any>();
  changeTimeCycle = new Subject<any>();
  followUP = new Subject<any>();
  exportXls = new Subject<any>();
  chartshowBy = new Subject<any>();
  phiChecked = false;
  showByKey: any;
  settingpopupclose = new Subject<any>();
  expendTree = new Subject<any>();
  client_key: any
  annotations: any = false
  getDataPatientJourneyDataHold = new Subject<any>();
  thresholdoldData: any;
  patientStatusCondition = false;
  filterLoadFlg = true;
  time_cycle:any;
  day_of_the_week:any;
  buffer_days:any
  // Extra navigation payload (clicked-cell context) merged into every baseQuery build.
  // Used only by isolated popup FilterService instances; undefined on the root singleton,
  // so normal pages are unaffected.
  extraNavPayload:any;
  isBufferDisable:boolean=false
  dashboardKey:any;
  pageKey:any;
  bookmarkFilterData:any;
  findSelectedAll:any = {};
  // DPM and DEM
  currentMsgOnDM: any;
  currentShowbySelection:any;
  triggerNestedQuery  = new Subject<any>();
  bufferSlider  = new Subject<any>();
  pageChangeDisplays:any = {};
  pageChangeDisplaysAll:any[] = [];
  
  constructor(private apiService: ApiService, private helperService: HelperService) {
    // Client Key Get from Local
    var client_key: any = sessionStorage.getItem("client");
    let value: any = JSON.parse(client_key);
    if (value) {
      this.client_key = value[0]?.client.client_key || ''
    }

  }

  loadData(method: string, url: string, key: string, data: any, dashboard_key?: any, report_typ?: any, pageInfo?: any,serverSideSearch?:any, fieldKey?:any, apiJSonFlag?:any,additionalParameter?:any,field?:any) {
    // debugger

if(apiJSonFlag) {
      let valueProp = field.templateOptions?.['valueProp'] || 'key';
      let labelProp = field.templateOptions?.['labelProp'] || 'name';

      if(url.includes('|')) {
        let result = url.split("|").map(item => {
        let [val, label] = item.split(",");
          return {
            [valueProp]: val,
            [labelProp]: label
          };
        });
        return new Observable((ob) => {
          ob.next(result);
        });

      } else {
        let endpnt = url.split(',');
        return new Observable((ob) => {
          ob.next(endpnt.map((value: string) => ({ [valueProp]: value })));
        });
      }
    }

    var client_key: any = sessionStorage.getItem("client");
    let value = JSON.parse(client_key);
    let request: any = {};
    request['dashboard_key'] = dashboard_key;
    request['page_key'] = this.pageKey;

    if(sessionStorage.getItem("brandKeyForFilters")) {
      const brand_key: any = sessionStorage.getItem("brandKeyForFilters");
      const brand = JSON.parse(brand_key);
      request['brand_key'] = brand;
    }
    if(additionalParameter) {
      Object.assign(request, additionalParameter);
    }
    
    if(sessionStorage.getItem("tbl_name_suffix_non_frm")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix_non_frm");
      json = JSON.parse(json);
      request['tbl_name_suffix'] = json.tbl_name_suffix;  
    }

    if (method.toUpperCase() == "POST") {
      if (key.includes('.')) {
        let keys = key.split(",");
        for (let k in keys) {
          let kv = keys[k].split(".");
          let keyName = kv[kv.length - 1];
          request[keyName] = this.helperService.newGetDataByPath(data, keys[k]);
        }
      } else {
        // request[key] = value[0].client.client_key

        // Get Item For Session Storage
        let brand_key: any = sessionStorage.getItem("brandKeyForFilters");
        if(!brand_key) {
          if(data?.['brand_key']?.brand_key) {
            brand_key = data['brand_key'].brand_key
          }
        }

        // Parameter Split
        let keyss = key.split(",")

        for (let k in keyss) {
          let keyName = keyss[k]
          if (keyName == 'username') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].user
          } else if (keyName == 'brand_key') {
            let value = JSON.parse(brand_key);
            request[keyName] = data ? data[keyName][keyName] ? data[keyName][keyName] : data[keyName] : value
          } else if (keyName == 'client_key') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].client.client_key
          } else if (keyName == 'user_id') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].user
          } else if (keyName == 'dashboard_key') {
            request[keyName] = dashboard_key ? dashboard_key : null
          } else if (keyName == 'report_typ') {
            if(data[keyName] && !this.brandBasedTime) {
              request[keyName] = data[keyName][keyName] || 'W';
            } else {
              request[keyName] =  report_typ || this.report_type || 'D';
            }
          } else if (keyName == 'source_nm') {
            request['source_key'] = data[keyName] ? data[keyName]['source_key'] : ''
          } else if (keyName == 'module_key') {
            if(sessionStorage.getItem("module")) {
              let module:any = sessionStorage.getItem("module");
              module = JSON.parse(module);
              request[keyName] = module.module_key;
            }
          } else if (keyName == 'time_date') {
            request['from_date'] = moment(data[keyName].from_date).format('yyyy-MM-DD')
            request['to_date'] = moment(data[keyName].to_date).format('yyyy-MM-DD')
          
          } else if (keyName == 'table_name') {
            request[keyName] = data[keyName].table_name
          } else if (keyName == 'db_schema_key') {
            request[keyName] = data[keyName].db_schema_key
          } else {
            request[keyName] = this.getFilter(data[keyName], keyName)
          }
        }

      }

      if(sessionStorage.getItem("tbl_name_suffix")) {
        let json:any = sessionStorage.getItem("tbl_name_suffix");
        json = JSON.parse(json);
        request['tbl_name_suffix'] = json.tbl_name_suffix;  
      }

      if(serverSideSearch) {
        this.serverSideVaribles[fieldKey] = request;
      }

      // Client Key Get from Local
      let value = JSON.parse(client_key);
      request["client_key"] = value[0].client.client_key
      request['employee_key'] = this.employKey
      if (pageInfo) Object.assign(request, { page_key: pageInfo });
      return this.apiService.posts(url, request);
    } else {
      return this.apiService.gets(url);
    }
  }

  loadDataNewMultiselection(method: string, endPoint: string, key: string, data?: any, dashboard_key?: any, serverSideSearch?:any, fieldKey?:any) {
    // data = Object.assign({}, this.selectedItem.multi, this.selectedItem.single);
    
    let client_key: any = sessionStorage.getItem("client");

    // Multi Select datas 
    if (method.toUpperCase() == "POST") {
      let request: any = {};
      request['dashboard_key'] = dashboard_key;
      request['page_key'] = this.pageKey;

      if(sessionStorage.getItem("brandKeyForFilters")) {
        const brand_key: any = sessionStorage.getItem("brandKeyForFilters");
        const brand = JSON.parse(brand_key);
        request['brand_key'] = brand;
      }

      if(sessionStorage.getItem("tbl_name_suffix_non_frm")) {
        let json:any = sessionStorage.getItem("tbl_name_suffix_non_frm");
        json = JSON.parse(json);
        request['tbl_name_suffix'] = json.tbl_name_suffix;  
      }

      if (key.includes('.')) {
        let keys = key.split(",");
        for (let k in keys) {
          let kv = keys[k].split(".");
          let keyName = kv[kv.length - 1];

          let dataApi = this.helperService.newGetDataByPath(data, keys[k]);
          request[keyName] = dataApi.length == 0 ? '' : dataApi;
        }
      } else {

        // Get Item For Session Storage
        let brand_key: any = sessionStorage.getItem("brandKeyForFilters");

        if(!brand_key) {
          if(data?.['brand_key']?.brand_key) {
            brand_key = data['brand_key'].brand_key
          }
        }

        // Parameter Split
        let keyss = key.split(",")

        for (let k in keyss) {
          let keyName = keyss[k]
          if (keyName == 'username') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].user
          } else if (keyName == 'brand_key') {
            let value = JSON.parse(brand_key);
            request[keyName] = value
          } else if (keyName == 'client_key') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].client.client_key
          } else if (keyName == 'dashboard_key') {
            request[keyName] = dashboard_key ? dashboard_key : null
          } else if (keyName == 'module_key') {
            if(sessionStorage.getItem("module")) {
              let module:any = sessionStorage.getItem("module");
              module = JSON.parse(module);
              request[keyName] = module.module_key;
            }
          } else if (keyName == 'time_date') {
            request['from_date'] = moment(data[keyName].from_date).format('yyyy-MM-DD')
            request['to_date'] = moment(data[keyName].to_date).format('yyyy-MM-DD')
          } else if (keyName == 'table_name') {
            request[keyName] = data[keyName].table_name
          } else if (keyName == 'db_schema_key') {
            request[keyName] = data[keyName].db_schema_key
          } else {
            request[keyName] = this.getFilter(data[keyName], keyName)
          }
        }
      }

      if(sessionStorage.getItem("tbl_name_suffix")) {
        let json:any = sessionStorage.getItem("tbl_name_suffix");
        json = JSON.parse(json);
        request['tbl_name_suffix'] = json.tbl_name_suffix;  
      }

      // Client Key Get from Local
      let value = JSON.parse(client_key);
      request["client_key"] = value[0].client.client_key
      request['employee_key'] = this.employKey

      if(serverSideSearch) {
        this.serverSideVaribles[fieldKey] = request;
      }

      return this.apiService.posts(endPoint, request);
    } else {
      return this.apiService.gets(endPoint);
    }
  }
  serverSideVaribles:any = {};
  
  loadDataMultiselection(method: string, endPoint: string, key: string, data?: any, dashboard_key?: any, apiJSonFlag?:any, field?:any,additionalParameter?:any) {
    let client_key: any = sessionStorage.getItem("client");
    // debugger
    if(apiJSonFlag) {
      let valueProp = field.templateOptions?.['valueProp'] || 'key';
      let labelProp = field.templateOptions?.['labelProp'] || 'name';

      if(endPoint.includes('|')) {
        let result = endPoint.split("|").map(item => {
        let [val, label] = item.split(",");
          return {
            [valueProp]: val,
            [labelProp]: label
          };
        });
        return new Observable((ob) => {
          ob.next(result);
        });

      } else {
        let endpnt = endPoint.split(',');
        return new Observable((ob) => {
          ob.next(endpnt.map((value: string) => ({ [valueProp]: value })));
        });
      }
    }
    // Multi Select datas 
    if (method.toUpperCase() == "POST") {
      let request: any = {};
      
      request['dashboard_key'] = dashboard_key;
      request['page_key'] = this.pageKey;
    
      if(sessionStorage.getItem("brandKeyForFilters")) {
        const brand_key: any = sessionStorage.getItem("brandKeyForFilters");
        const brand = JSON.parse(brand_key);
        request['brand_key'] = brand;
      }
    if(additionalParameter) {
      Object.assign(request, additionalParameter);
    }
      if(sessionStorage.getItem("tbl_name_suffix_non_frm")) {
        let json:any = sessionStorage.getItem("tbl_name_suffix_non_frm");
        json = JSON.parse(json);
        request['tbl_name_suffix'] = json.tbl_name_suffix;  
      }

      if (key.includes('.')) {
        let keys = key.split(",");
        for (let k in keys) {
          let kv = keys[k].split(".");
          let keyName = kv[kv.length - 1];

          let dataApi = this.helperService.newGetDataByPath(data, keys[k]);
          request[keyName] = dataApi.length == 0 ? '' : dataApi;
        }
      } else {

        // Get Item For Session Storage
        let brand_key: any = sessionStorage.getItem("brandKeyForFilters");
        if(!brand_key) {
          if(data?.['brand_key']?.brand_key) {
            brand_key = data['brand_key'].brand_key
          }
        }

        // Parameter Split
        let keyss = key.split(",")

        for (let k in keyss) {
          let keyName = keyss[k]
          if (keyName == 'username') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].user
          } else if (keyName == 'brand_key') {
            let value = JSON.parse(brand_key);
            request[keyName] = value
          } else if (keyName == 'client_key') {
            let value = JSON.parse(client_key);
            request[keyName] = value[0].client.client_key
          } else if (keyName == 'dashboard_key') {
            request[keyName] = dashboard_key ? dashboard_key : null
          } else if (keyName == 'module_key') {
            if(sessionStorage.getItem("module")) {
              let module:any = sessionStorage.getItem("module");
              module = JSON.parse(module);
              request[keyName] = module.module_key;
            }
          } else if (keyName == 'time_date') {
            request['from_date'] = moment(data[keyName].from_date).format('yyyy-MM-DD')
            request['to_date'] = moment(data[keyName].to_date).format('yyyy-MM-DD')
          } else if (keyName == 'table_name') {
            request[keyName] = data[keyName].table_name
          } else if (keyName == 'db_schema_key') {
            request[keyName] = data[keyName].db_schema_key
          } else {
            request[keyName] = this.getFilter(data[keyName], keyName)
          }
        }
      }

      if(sessionStorage.getItem("tbl_name_suffix")) {
        let json:any = sessionStorage.getItem("tbl_name_suffix");
        json = JSON.parse(json);
        request['tbl_name_suffix'] = json.tbl_name_suffix;  
      }

      // Client Key Get from Local
      let value = JSON.parse(client_key);
      request["client_key"] = value[0].client.client_key
      request['employee_key'] = this.employKey

      return this.apiService.posts(endPoint, request);
    } else {
      return this.apiService.gets(endPoint);
    }
  }

  getCycleDate(method: any, url: any, parameter: any, howLong: any, model: any, valueProp: any): Promise<any> {

    var client_key: any = sessionStorage.getItem("client");
    let request: any = {};

    if (parameter.includes('.')) {
      let keys = parameter.split(",");
      for (let k in keys) {
        let kv = keys[k].split(".");
        let keyName = kv[kv.length - 1];
        request[keyName] = model[keyName]
      }
    } else {
      // Get Item For Session Storage
      let brand_key: any = sessionStorage.getItem("brandKeyForFilters");
      if(!brand_key) {
        if(model?.['brand_key']?.brand_key) {
          brand_key = model['brand_key'].brand_key
        }
      }
      // Parameter Split
      let keyss = parameter.split(",")

      for (let k in keyss) {
        let keyName = keyss[k]
        if (keyName == 'username') {
          let value = JSON.parse(client_key);
          request[keyName] = value[0].user
        } else if (keyName == 'brand_key') {
          let value = JSON.parse(brand_key);
          request[keyName] = value
        } else if (keyName == 'client_key') {
          let value = JSON.parse(client_key);
          request[keyName] = value[0].client.client_key
        } else {
          request[keyName] = this.getFilter(model[keyName], keyName)
        }
      }
    }

    // Client Key Get from Local
    let value = JSON.parse(client_key);
    request["client_key"] = value[0].client.client_key
    request['employee_key'] = this.employKey
    return new Promise((resolve, reject) => {
      if (method.toUpperCase() == "POST") {
        this.apiService.post(url, request).subscribe((res) => {
          if (res.length > 0) {

            this.endDate = moment(res[0].dp_cycle_date).toDate();
            howLong = howLong.toString()
            if (howLong.includes('brand')) {
              this.startDate = moment(res[0]['dp_cycle_date']).toDate();
            } else {
              this.startDate = moment(res[0]['dp_cycle_date'])
                .add(-parseInt(howLong || 15), "days")
                .toDate();
            }

            this.selectedDate.start = this.startDate;
            this.selectedDate.end = this.endDate;
          }
          resolve(this.selectedDate);
        });
      } else {
        this.apiService.get(url).subscribe((res) => { });
      }
    });
  }

  setDateFromTimeCycle(data: any) {

    this.startDate = moment(data[0].from_dt).toDate();
    this.endDate = moment(data[0].to_dt).toDate();

    this.selectedDate.start = this.startDate;
    this.selectedDate.end = this.endDate;

    return this.selectedDate
  }

  setBadgeValue(key: string, value: any, length?: any, selectedItem?: any, path?: any, showBy?: any, labelProp?: any, selectedType?: any,data?:any, field?:any,label?:any,aditionalData?:any) {
  this.badges.find((b: any) => {
    if (b.key == key) {
      b.label= label ?? b.label;
      b.value = value;
      b.length = length;
      b.selectedData = selectedItem;
      b.path = path
      b.showBy = showBy
      b.labelProp = labelProp
      b.selectedType = selectedType || ''
      b.option=data
      b.field=field
      b.isGrouped= aditionalData?.isGrouped || false
      b.groupLabelProp= aditionalData?.groupLabelProp || ''
    }

    });
    this.badgeChanges.next(this.badges);
  }

  setFilterValue(values: any, queryParams?: any) {

    // auto query stored based on formly form data
    const query: any = {};
    for (let [key, value] of Object.entries(values)) {
      if (value instanceof String) {
        query[key] = value;
      } else if (value instanceof Date) {
        query[key] = moment(value).format("yyyy-MM-DD");
      } else if (value instanceof Object) {
        const v: any = value;
        if (v[key] == undefined) {
          if(v?.length) {
            let a: string = v?.map((a: any) => a[key]);
            query[key] = a.toString();
          } else {
            for (let ky in v) {
              if(v[ky] instanceof Date) {
                query[ky] = moment(v[ky]).format("yyyy-MM-DD"); ;
              } else {
                query[ky] = v[key]; 
              }
            }
          }
        } else {
          query[key] = v[key];
        }
      } else if (value instanceof Array) {
        query[key] = this.getFilter(value, key);
      } else if (isNull(value)) {
        query[key] = value;
      }
    }

    // brand assign to basequery for refreshed date
    var brand_key: any = sessionStorage.getItem("brandKeyForFilters");
    let brandKey = JSON.parse(brand_key);

    // Client Key Get from Local
    var client_key: any = sessionStorage.getItem("client");
    let value = JSON.parse(client_key);
    this.client_key = value[0].client.client_key || ''

    // client_key added into baseQuery and brandkey and dublicate key from filter configuration
    
    // if(this.brandBasedTime) {
      Object.assign(query, {'time_cycle': this.time_cycle});
      Object.assign(query, {'day_of_the_week': this.day_of_the_week ?? undefined});
    // }
      Object.assign(query, {'buffer_days': this.buffer_days ?? undefined});

    this.baseQuery = Object.assign(query, {
      'client_key': this.client_key,
      'dashboard_key': this.dashboardKey,
      'page_key': this.pageKey,
      'brand_key': query['brand_key'] ? query['brand_key'] : brandKey,
      'employee_key': this.getEmpKey() ? this.getEmpKey() : this.employKey,
    }, this.duplicateParameter);

    if(sessionStorage.getItem("tbl_name_suffix_non_frm")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix_non_frm");
      json = JSON.parse(json);
      this.baseQuery['tbl_name_suffix'] = json.tbl_name_suffix;  
    }

    if(sessionStorage.getItem("tbl_name_suffix")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix");
      json = JSON.parse(json);
      this.baseQuery['tbl_name_suffix'] = json.tbl_name_suffix;  
    }

    // debugger
    if (Object.keys(this.selectAllNullColumn).length>0) {
      for (const key in this.selectAllNullColumn) {
        if (this.selectAllNullColumn.hasOwnProperty(key)) {
          if (this.selectAllNullColumn[key] === null) {
            this.baseQuery[key] = null;
          }
        }
      }
    }

    // Object.keys(this.selectAllNullColumn)
    // if (this.showByInGrid) {
    //   this.baseQuery = Object.assign(this.baseQuery, { 'brand_uom_xref_key': this.showByKey });
    // }

    // remove 'Null' string
    this.baseQuery = this.removeNullValues(this.baseQuery)

    // dublicate of this.baseQuery
    this.testing = this.baseQuery

    // Navigation Payload Data

    // debugger

    if (sessionStorage.getItem("payloadData") && (queryParams?.['cardName'] || (queryParams?.['record'] == 'yes'))) {
      let pylodData: any = sessionStorage.getItem("payloadData");
      pylodData = JSON.parse(pylodData);
      if (Object.keys(pylodData).length > 0) {
        this.baseQuery = Object.assign(this.baseQuery, pylodData);
      }
    }

    // Isolated popup sessions inject the clicked-cell context here (in-memory, no sessionStorage),
    // so every filter re-emit inside the popup keeps the cell payload and doesn't fail.
    if (this.extraNavPayload && Object.keys(this.extraNavPayload).length > 0) {
      this.baseQuery = Object.assign(this.baseQuery, this.extraNavPayload);
    }


    // Main
    // debugger
    this.allLocationData = {};
    this.patientStatusJouneryArray = {};  // FRM patient status journey
    this.filterQuery.next(this.baseQuery);
      
      this.filterLoadFlg = false;
      // reset
      this.resetToDefault()
  }

  removeNullValues(obj: any) {
    for (let key in obj) {
      if (obj[key] === "null") {
        delete obj[key];
      }
    }
    return obj;
  }

  getEmpKey() {
    let emp: any = sessionStorage.getItem("employee_key");
    let employee_key = JSON.parse(emp)
    this.employKey = employee_key?._value || ''
    return employee_key?._value || null
  }

  // Reset Default Functionallity
  resetToDefault() {
    // debugger
    let resetFilterLength = ''
    this.badges.forEach((res: any) => {
      if(res.path == 'formlyYearlySelection') {
        let allDate: any = Object.entries(this.allOptionData?.formly_yearly_selection).map(([key, value]) => ({ key, value }));
        let selectDate: any = Object.entries(this.selectedItem?.formly_yearly_selection).map(([key, value]) => ({ key, value }));

        if (allDate.length) {
          this.allDefaultDate['formly_yearly_selection'] = [];
          allDate.forEach((f:any, i:any) => {

            let allData = {
              key: f.key,
              selectedDate: allDate[i].value.selectedDate,
            }
            this.allDefaultDate['formly_yearly_selection'].push(allData);
            
            let data = selectDate.find((o:any) => o.key === f.key);
            if (data) {
              if (allDate[i].value.selectedDate !== data.value.selectedDate) {
                resetFilterLength = '1';
              }
            }
          });
        }

      } else if(res.path == 'formlyDateRangeSelection') {
        let allDate: any = Object.entries(this.allOptionData?.formly_date).map(([key, value]) => ({ key, value }));
        let selectDate: any = Object.entries(this.selectedItem?.formly_date).map(([key, value]) => ({ key, value }));
        
        if (allDate.length) {
          this.allDefaultDate['formly_date'] = [];
          allDate.forEach((f:any, i:any) => {

            let allData = {
              key: f.key,
              from_date: allDate[i].value.start,
              to_date: allDate[i].value.end
            }
            this.allDefaultDate['formly_date'].push(allData);
            
            let data = selectDate.find((o:any) => o.key === f.key);
            if (data) {
              if (allDate[i].value.start !== data.value.start || allDate[i].value.end !== data.value.end) {
                resetFilterLength = '1';
              }
            }
          });
        }
      } else if (res.path == 'singleDateSelection') {
        const allData: any = sessionStorage.getItem('date-single-default-load');
        const selectData: any = sessionStorage.getItem('userStateSingleDate');
        
        let serializedDataAll: any = JSON.parse(allData);
        this.allDefaultDate['from_date'] = serializedDataAll.time_date;
        this.allDefaultDate['to_date'] = serializedDataAll.time_date;

        if (selectData) {
          const serializedDataSelect: any = JSON.parse(selectData);
          if (serializedDataSelect.time_date != serializedDataAll.time_date) {
            resetFilterLength = '1'
          }
        }
      } else if (res.path.includes('multi')) {
        let allMulti: any = Object.entries(this.allOptionData.multi).map(([key, value]) => ({ key, value }));
        let selectMulti: any = Object.entries(this.selectedItem.multi).map(([key, value]) => ({ key, value }));

        for (let i = 0; i < allMulti.length; i++) {
          if (allMulti[i].key.toLowerCase() == res.key.toLowerCase()) {
            let something = selectMulti.find((d: any) => d.key.toLowerCase() == allMulti[i].key.toLowerCase())
            if (something) {
              if (something.value.length != allMulti[i].value.length) {
                resetFilterLength += i
              }
            }
          }
        }
      } else if (res.path.includes('single')) {
        let allSingle: any = Object.entries(this.allOptionData.single).map(([key, value]) => ({ key, value }));
        let selectSingle: any = Object.entries(this.selectedItem.single).map(([key, value]) => ({ key, value }));

        for (let i = 0; i < allSingle.length; i++) {
          if (allSingle[i].key.toLowerCase() == res.key.toLowerCase()) {
            let something = selectSingle.find((d: any) => d.key.toLowerCase() == allSingle[i].key.toLowerCase())
            if (something) {
              if (something.value[something.key] != allSingle[i].value[allSingle[i].key]) {
                resetFilterLength += i
              }
            }
          }
        }
      } else if (res.path.includes('date')) {

        let allDate: any = Object.entries(this.allOptionData?.date).map(([key, value]) => ({ key, value }));
        let selectDate: any = Object.entries(this.selectedItem?.date).map(([key, value]) => ({ key, value }));

        this.allDefaultDate['from_date'] = allDate?.[0]?.value?.start;
        this.allDefaultDate['to_date'] = allDate?.[0]?.value?.end;

        if (allDate[0].value.start != selectDate[0].value.start || allDate[0].value.end != selectDate[0].value.end) {
          resetFilterLength = '1'
        }
      } else if (res.path.includes('timeCycle')) {


        if (res.selectedType!='Q') {

          const allData: any = sessionStorage.getItem('timeWithoutQuarterFromAndToDefault');
          const selectData: any = sessionStorage.getItem('timeWithoutQuarterFromAndToSelected');
          
          let serializedDataAll: any = JSON.parse(allData);
          this.allDefaultDate['from_date'] = moment(serializedDataAll.from_date).format('MM-DD-YYYY');
          this.allDefaultDate['to_date'] = moment(serializedDataAll.to_date).format('MM-DD-YYYY');

          if (selectData) {
            const serializedDataSelect: any = JSON.parse(selectData);


            if (serializedDataSelect) {
              if (moment(serializedDataSelect.from_date).format('MM-DD-YYYY') != moment(serializedDataAll.from_date).format('MM-DD-YYYY') ||
                moment(serializedDataSelect.to_date).format('MM-DD-YYYY') != moment(serializedDataAll.to_date).format('MM-DD-YYYY')) {
                resetFilterLength = '1'
              }
            }

          }

        } else {

          const allData: any = sessionStorage.getItem('timeQuarterFromAndToDefault');
          const selectData: any = sessionStorage.getItem('timeQuarterFromAndToSelected');
          
          let serializedDataAll: any = JSON.parse(allData);
          this.allDefaultDate['from_date'] = serializedDataAll.from_date;
          this.allDefaultDate['to_date'] = serializedDataAll.to_date;

          if (selectData) {
            const serializedDataSelect: any = JSON.parse(selectData);


            if (serializedDataSelect) {
              if (serializedDataSelect.from_date != serializedDataAll.from_date || serializedDataAll.to_date != serializedDataSelect.to_date) {
                resetFilterLength = '1'
              }
            }

          }
        }

      } else if (res.path.includes('timeSingle')) {


        if (res.selectedType!='Q') {

          const allData: any = sessionStorage.getItem('singleTimeWithoutQuarterFromAndToDefault');
          const selectData: any = sessionStorage.getItem('singleTimeWithoutQuarterFromAndToSelected');

          let serializedDataAll: any = JSON.parse(allData);
          this.allDefaultDate['from_date'] = serializedDataAll.from_date;
          this.allDefaultDate['to_date'] = serializedDataAll.to_date;

          if (selectData) {
            const serializedDataSelect: any = JSON.parse(selectData);

            if (serializedDataSelect) {
              if (moment(serializedDataSelect.from_date).format('MM-DD-YYYY') != moment(serializedDataAll.from_date).format('MM-DD-YYYY') ||
                moment(serializedDataSelect.to_date).format('MM-DD-YYYY') != moment(serializedDataAll.to_date).format('MM-DD-YYYY')) {
                resetFilterLength = '1'
              }
            }

          }

        } else {

          const allData: any = sessionStorage.getItem('singleTimeQuarterFromAndToDefault');
          const selectData: any = sessionStorage.getItem('singleTimeQuarterFromAndToSelected');
          
          let serializedDataAll: any = JSON.parse(allData);
          this.allDefaultDate['from_date'] = serializedDataAll.from_date;
          this.allDefaultDate['to_date'] = serializedDataAll.to_date;

          if (selectData) {
            const serializedDataSelect: any = JSON.parse(selectData);

            if (serializedDataSelect) {
              if (serializedDataSelect.from_date != serializedDataAll.from_date || serializedDataAll.to_date != serializedDataSelect.to_date) {
                resetFilterLength = '1'
              }
            }

          }
        }

      } else if (res.path.includes('Range')) {

        const data: any = sessionStorage.getItem('quarterFromAndTo');
        if (data) {
          const serializedData: any = JSON.parse(data);

          let allDate2: any = Object.entries(serializedData[1].quarterTo).map(([key, value]) => ({ key, value }));
          let selectDate2: any = Object.entries(this.selectedItem.quarterTo).map(([key, value]) => ({ key, value }));

          if (selectDate2?.[0]?.value) {
            let ab = allDate2?.[0]?.value?.['quarter,year'].replace(/\s+/g, "")
            let cb = selectDate2?.[0]?.value?.['quarter,year'].replace(/\s+/g, "")
            
            this.allDefaultDate['from_date'] = ab;
            this.allDefaultDate['to_date'] = cb;

            if (ab != cb) {
              resetFilterLength = '1'
            }
          }

          let allDateFrom: any = Object.entries(serializedData[0].quarterFrom).map(([key, value]) => ({ key, value }));
          let selectDateFrom: any = Object.entries(this.selectedItem.quarterFrom).map(([key, value]) => ({ key, value }));

          if (selectDateFrom?.[0]?.value) {
            let ab = allDateFrom?.[0]?.value?.['quarter,year'].replace(/\s+/g, "")
            let cb = selectDateFrom?.[0]?.value?.['quarter,year'].replace(/\s+/g, "")

            this.allDefaultDate['from_date'] = ab;
            this.allDefaultDate['to_date'] = cb;

            if (ab != cb) {
              resetFilterLength = '1'
            }
          }

        }



      } else if (res.path.includes('quarter')) {

        const data: any = sessionStorage.getItem('quarterFromAll');
        if (data) {
          const serializedData: any = JSON.parse(data);

          let defDate = serializedData?.quarterFrom?.quarter_select?.['quarter,year']
          let selectDate: any = Object.entries(this.selectedItem.quarter).map(([key, value]) => ({ key, value }));
          
          this.allDefaultDate['from_date'] = defDate;
          this.allDefaultDate['to_date'] = defDate;

          if (selectDate.length) {
            if (defDate != selectDate?.[0]?.value?.['quarter,year']) {
              resetFilterLength = '1'
            }
          }
        }
      }
    })

    if (resetFilterLength != '') {
      this.badgeCheck = true
    } else {
      this.badgeCheck = false
    }
  }

  // convert to stringify
  getFilter(data: any, paramName: any) {
    if (data === null || data === undefined) return null;

    // If data is a plain object, return data[paramName] directly
    if (!Array.isArray(data) && typeof data === "object") {
      return data[paramName] ?? null;
    }

    // If data is an array, keep the existing behavior
    if (data.length == 0) return null;
    let filter = "";
    data.map((e: any) => {
      filter += e[paramName] + ",";
    });
    return filter.slice(0, filter.lastIndexOf(","));
  }

  // All Execution 
  executeQuery(obj: any, endPoint?:any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    query["report_typ"] = this.report_type;
    // query['report_key']=undefined
    return this.apiService.post(endPoint || "kpi/get-execution-details", query);
  }
  dragexecuteQuery(obj: any,variable:any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    query['report_key'] = query?.kpi_key || query[variable];
    return this.apiService.post("kpi/get-execution-details", query);
  }

   dynamicLabelQuery(obj: any,url:any) {
    obj['dashboard_key']= this.dashboardKey,
    obj['page_key']= this.pageKey
    return this.apiService.post(url, obj);
  }

  // Heat Map Card Execution
  kpiBreakdownQuery(obj: any, endPoint:any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    sessionStorage.setItem("kpiBaseQuery", JSON.stringify(query))
    // query['report_key']=undefined
    return this.apiService.post(endPoint || "kpi/get-execution-details", query);
  }

  // Control Chart Execution
  kpiBreakdownexecuteQuery(api_key: string,) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery)
    query["api_key"] = api_key;
    query["report_typ"] = 'D';
    query["time_cycle"] = this.report_type;
    query['report_key'] = undefined

    return this.apiService.post("kpi/get-execution-details", query);
  }

  // Threshold Execution
  thresholdsexecuteQuery(obj: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)

    query["report_typ"] = 'I';
    query["time_cycle"] = this.report_type;
    query['report_key'] = undefined

    return this.apiService.post("kpi/get-execution-details", query);
  }

  // KPI Breakdown Popup Execution
  kpiBreakdownexecuteQuerypopup(api_key: string,) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));

    let kpiquery: any = sessionStorage.getItem("kpiBaseQuery")
    kpiquery = JSON.parse(kpiquery)

    let query: any = Object.assign({}, this.baseQuery)
    let queryData: any = {
      "brand_key": this.baseQuery["brand_key"],
      "source_nm": kpiquery["source_nm"],
      "client_key": 2001,
      "api_key": api_key,
      "source_type": "HUB,SP",
      "source_key": "3001,3002,3003,3004,2005",
      "kpi_key": "200101,200102,200103,200104,200105,200106,200107,200108,200109,200110,200111,200112,200113,200114,200115,200116,200117,200118,200119,200120,200124,200125,200126,200127,200128,999999",
      "report_typ": "D",
      "time_cycle": this.report_type,

    }
    // query['report_key']=undefined
    if (!this.hasMethodExecuted) {
      // Your code to be executed only once
      queryData["from_date"] = kpiquery["from_date"],
        queryData["to_date"] = kpiquery["to_date"]

      // Set the flag to true to ensure it doesn't execute again
      this.hasMethodExecuted = true;
    } else {

      if (this.report_type == 'W') {
        queryData["from_date"] = moment(query["to_date"]).subtract(6, 'd').toDate();
        queryData["from_date"] = moment(queryData["from_date"]).format('yyyy-MM-DD')
        queryData["to_date"] = query["to_date"]//this.kpiDateRange[0].to_dt
      } else if (this.report_type == 'M') {
        queryData["from_date"] = moment(query["to_date"]).startOf('month').toDate()
        queryData["from_date"] = moment(queryData["from_date"]).format('yyyy-MM-DD')
        queryData["to_date"] = query["to_date"]//this.kpiDateRange[0].to_dt
      } else if (this.report_type == 'Q') {
        let findDate = this.getQuarter(query["to_date"])
        queryData["from_date"] = findDate?.from_date
        queryData["from_date"] = moment(queryData["from_date"]).format('yyyy-MM-DD')
        queryData["to_date"] = findDate?.to_date
      } else if (this.report_type == 'Y') {
        queryData["from_date"] = moment(query["to_date"]).startOf('year').toDate()
        queryData["from_date"] = moment(queryData["from_date"]).format('yyyy-MM-DD')
        queryData["to_date"] = query["to_date"]//this.kpiDateRange[0].to_dt
      }
    }

    return this.apiService.post("kpi/get-execution-details", queryData);
  }

  // get a date for KPI Breakdown Popup Execution 
  getQuarter(date: any) {

    let year = moment(date).year()
    let month = moment(date).month()

    let toOption: any = [
      { value: 'Q1', months: ['Jan', 'Feb', 'Mar'], "monthFound": '1,2,3' },
      { value: 'Q2', months: ['Apr', 'May', 'Jun'], "monthFound": '4,5,6' },
      { value: 'Q3', months: ['Jul', 'Aug', 'Sep'], "monthFound": '7,8,9' },
      { value: 'Q4', months: ['Oct', 'Nov', 'Dec'], "monthFound": '10,11,12' }
    ];

    toOption.forEach((res: any) => {
      if (res.value == 'Q1') {
        Object.assign(res,
          { "from_date": year + '-' + '01' + '-' + '01' },
          { "to_date": year + '-' + '03' + '-' + '31' }, { "year": year })
      } else if (res.value == 'Q2') {
        Object.assign(res,
          { "from_date": year + '-' + '04' + '-' + '01' },
          { "to_date": year + '-' + '06' + '-' + '30' }, { "year": year })
      } else if (res.value == 'Q3') {
        Object.assign(res,
          { "from_date": year + '-' + '07' + '-' + '01' },
          { "to_date": year + '-' + '09' + '-' + '30' }, { "year": year })
      } else if (res.value == 'Q4') {
        Object.assign(res,
          { "from_date": year + '-' + '10' + '-' + '01' },
          { "to_date": year + '-' + '12' + '-' + '31' }, { "year": year })
      }
    })

    return toOption.find((o: any) => o.monthFound.includes(month))
  }

  // getTimecycledata(postData: any, dashboardKey: any) {
  //   let postvalue: any = {
  //     "brand_key": postData["brand_key"] || 200104,
  //     "dashboard_key": dashboardKey,
  //     "client_key": this.client_key,
  //     "report_typ": postData["report_typ"] || "Q",
  //     "employee_key": this.employKey
  //   }

  //   return this.apiService.post("kpi/get-timecycle-date", postvalue);
  // }

  // FRM Portal Execution
  frmExecutionQuery(obj: any, endpoint:any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)

    return this.apiService.post(endpoint || "PSS/get-pss-data", query);
  }
  
  // FRM frmGetStatus Execution
  frmGetStatus(obj: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)

    return this.apiService.post("PSS/get-frm-patinetid-status", query);
  }

  // FRM Portal Update Status List Execution
  frmUpdateList(obj: any, endpoint:any) {
    if (!this.baseQuery) {
      let baseQuery: any = sessionStorage.getItem("baseQueryPatientStatusChange");
      this.baseQuery = baseQuery ? JSON.parse(baseQuery) : {}
    }

    let query = Object.assign({}, this.baseQuery, obj)
    return this.apiService.post(endpoint || "PSS/get-pss-data", query);
  }

  // FRM Portal Alert Remove and Update Execution
  frmRemoveAlerts(obj: any) {
    let query = Object.assign({}, this.baseQuery, obj)
    return this.apiService.post("kpi/get-execution-details", query);
  }

  // FRM Module - Update Patient Status
  updateStatus(query: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let data = Object.assign({}, this.baseQuery, query)
    return this.apiService.post("kpi/get-execution-details", data);
  }

  // Bullet Chart and some others Execution
  executePatientQuery(obj: any, endPoint?:any) {
    var empkey: any = sessionStorage.getItem("employee_key");
    let employee: any = JSON.parse(empkey);
    this.employKey = employee?._value
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    // query["source_key"] = this.source_key || undefined

    return this.apiService.post(endPoint || "kpi/get-execution-details", query);
  }
  
  // Bullet Chart and some others Execution
  executePssPatientQuery(obj: any) {
    var empkey: any = sessionStorage.getItem("employee_key");
    let employee: any = JSON.parse(empkey);
    this.employKey = employee?._value
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    // query["source_key"] = this.source_key || undefined

    return this.apiService.post("kpi/get-execution-details", query);
  }
  executebulletQuery(obj: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)

    return this.apiService.post("kpi/get-execution-details", query);
  }

  // IR Execution
  IRexecuteQuery(obj: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj)
    return this.apiService.post("kpi/get-execution-details", query);
  }

  // Comment Api
  commentsQuery(postdata: any, single_source?:any) {
    // console.log(postdata)
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));

    let query = Object.assign({}, this.baseQuery, postdata)
    //  make undefined which is not value
    let modelKey = Object.keys(query);
    modelKey.forEach((key: any) => {
      if (!query.hasOwnProperty(key)) {
        this.model[key] = undefined
      }
    });

    if (single_source) {
      query["source_key"] = postdata?.source_key || undefined;
    }

    query['report_key'] = undefined

    return this.apiService.post("api/notes/notes-data", query);
  }
    anomalyQuery(postdata: any) {
    // console.log(postdata)
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));

    let query = Object.assign({}, this.baseQuery, postdata)
    //  make undefined which is not value
    let modelKey = Object.keys(query);
    modelKey.forEach((key: any) => {
      if (!query.hasOwnProperty(key)) {
        this.model[key] = undefined
      }
    });
    query['report_key'] = undefined

    return this.apiService.post("kpi/kpi-anomoly-status-insert", query);
  }
  
  notesInsertQuery(postdata: any) {
    let query = Object.assign({}, postdata);
    return this.apiService.post("api/notes/notes-data", query);
  }

  // Comment Api
  alertNotificationData(postdata: any) {
    // console.log(postdata)
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, postdata)

    return this.apiService.post("kpi/get-execution-details", query);
  }

  // Comment Api
  alertNotificationFilter(postdata: any) {
    return this.apiService.post("api/alerts/get-alerts", postdata);
  }

  // get Json Data From Local
  getSampleJsonData(fileName: any) {
    return this.apiService.getDoc(fileName)
  }

  // Show By UOM 
  executeQueryForShowBy(query: any) {
    return this.apiService.post("kpi/get-uom-data", query);
  }
  loadshowByApi(obj?: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj);
    return this.apiService.post("/kpi/get-ir-showby-filter", query);
  }

  changeFilters(title: any) {
    setTimeout(() => {
      this.emitFilterChange.next(title);
    }, 2000);
  }

  // Time Cycle Execution
  selfTimeCycleExecuteQuery(obj: any) {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery, obj);
    return this.apiService.post("kpi/get-execution-details", query);
  }

  // Reset Funtionality to remove all session stored
  resetFilter() {

    this.bookmarkFilterData = {};
    // reset the filter based on carry to next screens 
    this.resetFilterAndPayloadInNavDetails();

    // netWork Status Refresh
    sessionStorage.removeItem('net_status_flr')

    // sessionStorage.removeItem('selectedKPIcontrol')
    sessionStorage.removeItem('singleTimeCycleQuarter')
    
    // single date selection
    sessionStorage.removeItem('userStateSingleDate');
    
    // sessionStorage.removeItem('recdetailGrid');
    // sessionStorage.removeItem("netWorkPayloads");

    // User State for session stored
    let resFil: any = sessionStorage.getItem("userState");
    let reset: any = JSON.parse(resFil)

    if (reset) {
      if (reset.selectedFilters) {
        reset.selectedFilters = {}
        const serializedData: any = JSON.stringify(reset);
        sessionStorage.setItem("userState", serializedData);
      }
    }

    // Time cycle filter user state carring
    this.resetForBrandBased();

    // Time cycle Single filter user state carring
    let resFilTimeSingle: any = sessionStorage.getItem("userStateTimeSingle");
    let resetTimeSingle: any = JSON.parse(resFilTimeSingle)

    if (resetTimeSingle) {
      if (resetTimeSingle.selectedFilters) {
        resetTimeSingle.selectedFilters = {}
        const serializedDataTime: any = JSON.stringify(resetTimeSingle);
        sessionStorage.setItem("userStateTimeSingle", serializedDataTime);
        sessionStorage.removeItem('singleTimeQuarterFromAndToSelected');
        sessionStorage.removeItem('singleTimeWithoutQuarterFromAndToSelected');

        sessionStorage.removeItem('singleTimeWithoutQuarterFromAndToDefault');
        sessionStorage.removeItem('singleTimeQuarterFromAndToDefault');
      }
    }

    // User State for session stored
    this.resetForKpiSingle();
    this.resetForBrandBasedSingle();

    //  delete model values for filter
    let modelKey = Object.keys(this.model);
    modelKey.forEach((key: any) => {
      if (this.model.hasOwnProperty(key)) {
        this.model[key] = ''
      }
    })

    if (!(Object.keys(this.filterReset).length === 0)) {
      this.filterReset.resetModel()
    }

    this.formReset.next(true)
    this.badgeCheck = false
    this.filterCheck = true
  }

  resetFilterAndPayloadInNavDetails() {
    let navPag: any = sessionStorage.getItem('routerNavDetailPages');
    sessionStorage.removeItem('filterData');

    if (navPag) {
      navPag = JSON.parse(navPag);

      if (navPag.length > 0) {
        navPag.map((m: any) => {
          if (m.filter) delete m.filter
          if (m.payload) delete m.payload
        })

        sessionStorage.setItem('routerNavDetailPages', JSON.stringify(navPag));
      }
    }
  }

  resetForKpiSingle() {
    // User State for session stored
    let resFilterKPI: any = sessionStorage.getItem("userStateKpiSingle");
    let resetKPISingle: any = JSON.parse(resFilterKPI)

    if (resetKPISingle) {
      if (resetKPISingle.selectedFilters) {
        resetKPISingle.selectedFilters = {}
        const serializedData: any = JSON.stringify(resetKPISingle);
        sessionStorage.setItem("userStateKpiSingle", serializedData);
      }
    }
  }

  resetForBrandBased() {
    // Time cycle filter user state carring
    let resFilTime: any = sessionStorage.getItem("userStateTime");
    let resetTime: any = JSON.parse(resFilTime)

    if (resetTime) {
      if (resetTime.selectedFilters) {
        resetTime.selectedFilters = {}
        const serializedDataTime: any = JSON.stringify(resetTime);
        sessionStorage.setItem("userStateTime", serializedDataTime);
        sessionStorage.removeItem('timeQuarterFromAndToSelected');
        sessionStorage.removeItem('timeWithoutQuarterFromAndToSelected');

        sessionStorage.removeItem('timeWithoutQuarterFromAndToDefault');
        sessionStorage.removeItem('timeQuarterFromAndToDefault');
      }
    }
  }

  resetForBrandBasedSingle() {

    // Time cycle Single filter user state carring
    let resFilTimeSingle: any = sessionStorage.getItem("userStateTimeSingle");
    let resetTimeSingle: any = JSON.parse(resFilTimeSingle)

    if (resetTimeSingle) {
      if (resetTimeSingle.selectedFilters) {
        resetTimeSingle.selectedFilters = {}
        const serializedDataTime: any = JSON.stringify(resetTimeSingle);
        sessionStorage.setItem("userStateTimeSingle", serializedDataTime);
        sessionStorage.removeItem('singleTimeQuarterFromAndToSelected');
        sessionStorage.removeItem('singleTimeWithoutQuarterFromAndToSelected');

        sessionStorage.removeItem('singleTimeWithoutQuarterFromAndToDefault');
        sessionStorage.removeItem('singleTimeQuarterFromAndToDefault');
      }
    }
  }

  kpidateRange(timeCycle: any, endDate: any) {
    let fromDate: any
    if (timeCycle == 'W') {
      fromDate = moment(endDate).subtract(6, 'd').toDate();
      endDate = endDate
    } else if (timeCycle == 'M') {
      fromDate = moment(endDate).startOf('month').toDate()
      endDate = endDate
    } else if (timeCycle == 'Q') {
      let findDate = this.getQuarter(endDate)
      fromDate = findDate?.from_date
      endDate = findDate?.to_date
    } else if (timeCycle == 'Y') {
      fromDate = moment(endDate).startOf('year').toDate()
      endDate = endDate
    }
    let kpiquery: any = sessionStorage.getItem("kpiBaseQuery")
    kpiquery = JSON.parse(kpiquery)
    if (!this.hasMethodExecuted) {

      return moment(kpiquery['from_date']).format('MMM DD, yyyy') + " - " + moment(kpiquery['to_date']).format('MMM DD, yyyy')
      // Set the flag to true to ensure it doesn't execute again
      this.hasMethodExecuted = true;
    } else {

      return moment(fromDate).format('MMM DD, yyyy') + " - " + moment(endDate).format('MMM DD, yyyy')
    }

  }

  filterApplyBtn() {
    // window.colState = '';
    // sessionStorage.removeItem('window.colState');
    // this.userActivityService.hierarchicalGridState
  }

  getBrandLogo(selectedOption:any) {
    let logo:any = sessionStorage.getItem('logos')
    logo= JSON.parse(logo)
    if(logo?.length){
      let brandLogo:any = logo.find((lo:any)=>lo.brand_key==selectedOption?.brand_key);
      if (brandLogo==undefined) {
        //  console.log("Brand Logo not found for "+ selectedOption?.brand_name)
        this.logoChange.next({logo:'',colour_codes:['#AA62AA','#680868','#AA62AA']});
        return
      }
      let logodata:any={
        logo:brandLogo.logo_path || '',
        colour_codes:brandLogo.colour_codes
      }
      this.logoChange.next(logodata);
      return brandLogo.logo_path;
    }
  }

  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0;
  }
  testQuery = {};
 
  findTheExceptionsFilter(selectedFilter:any) { 
    // this.globalFilterFields = this.globalFilterFields.filter((f:any)=> f.key != 'lagging_indicator');
  }

   // Prefixes for localStorage keys
  private readonly SHOW_BY_PREFIX = 'showBySelection_';
  private readonly NESTED_INDEX_PREFIX = 'nestedWidgetIndex_';
  private readonly SELECTION_TOGGLE_PREFIX = 'selectionToggle_';

  // Optional: keep track of used keys (not strictly needed, but helpful for debugging)
  private usedWidgetKeys = new Set<string>();

  // --- ShowBy Selection ---
  setShowBySelection(widgetKey: string, value: any): void {
    sessionStorage.setItem(`${this.SHOW_BY_PREFIX}${widgetKey}`, JSON.stringify(value));
    this.usedWidgetKeys.add(widgetKey);
  }
  
  // --- ShowByMap Selection ---
  setShowByMapSelection(widgetKey: string, value: any): void {
    sessionStorage.setItem(`${'showBymapSelection'}${widgetKey}`, JSON.stringify(value));
    this.usedWidgetKeys.add(widgetKey);
  }

  getShowBySelection(widgetKey: string): any {
    const item = sessionStorage.getItem(`${this.SHOW_BY_PREFIX}${widgetKey}`);
    if (item) {
      this.usedWidgetKeys.add(widgetKey); // ensure tracking
      return JSON.parse(item);
    }
    return null;
  }
  
  getShowByMapSelection(widgetKey: string): any {
    const item = sessionStorage.getItem(`${'showBymapSelection'}${widgetKey}`);
    if (item) {
      this.usedWidgetKeys.add(widgetKey); // ensure tracking
      return JSON.parse(item);
    }
    return null;
  }

  // --- Selection Toggle ---
  setSelectionToggle(widgetKey: string, value: any): void {
    sessionStorage.setItem(`${this.SELECTION_TOGGLE_PREFIX}${widgetKey}`, JSON.stringify(value));
    this.usedWidgetKeys.add(widgetKey);
  }

  getSelectionToggle(widgetKey: string): any {
    const item = sessionStorage.getItem(`${this.SELECTION_TOGGLE_PREFIX}${widgetKey}`);
    if (item) {
      this.usedWidgetKeys.add(widgetKey);
      return JSON.parse(item);
    }
    return null;
  }

  // --- Nested Widget Index ---
  setNestedWidgetIndex(widgetKey: string, index: number): void {
    sessionStorage.setItem(`${this.NESTED_INDEX_PREFIX}${widgetKey}`, index.toString());
    this.usedWidgetKeys.add(widgetKey);
  }

  getNestedWidgetIndex(widgetKey: string): number | undefined {
    const item = sessionStorage.getItem(`${this.NESTED_INDEX_PREFIX}${widgetKey}`);
    if (item) {
      this.usedWidgetKeys.add(widgetKey);
      return Number(item);
    }
    return undefined;
  }

  // ✅ DYNAMIC CLEANUP: Remove ALL stored widget states
  clearAllWidgetStates(): void {
    // Get all keys in localStorage
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(this.SHOW_BY_PREFIX) || key?.startsWith(this.NESTED_INDEX_PREFIX) || key?.startsWith(this.SELECTION_TOGGLE_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    }
    // Optional: clear tracked keys
    this.usedWidgetKeys.clear();
  }

  // ✅ (Optional) Remove state for a specific widget
  clearWidgetState(widgetKey: string): void {
    sessionStorage.removeItem(`${this.SHOW_BY_PREFIX}${widgetKey}`);
    sessionStorage.removeItem(`${this.NESTED_INDEX_PREFIX}${widgetKey}`);
    sessionStorage.removeItem(`${this.SELECTION_TOGGLE_PREFIX}${widgetKey}`);
    this.usedWidgetKeys.delete(widgetKey);
  }

  // ✅ (Optional) Get list of tracked widget keys (for debugging)
  getTrackedWidgetKeys(): string[] {
    return Array.from(this.usedWidgetKeys);
  
  }

  getDecommLabel(res:any, payload:any, find_filter_key:any, flag_name:any) {
    let fndField = this.globalFilterFields.find((f:any) => f.key == find_filter_key);
    let cnfg = fndField?.templateOptions || undefined;
    
    let singleItems = this.previousSingleSelectedItems?.[find_filter_key];
    // if(fndField.type == 'dynamic-select') {
    // } else {
    //   let multiItems = this.filterService.previousSelectedItems?.[find_filter_key];
    // }

    if(cnfg 
      && (cnfg?.decomm_flag == 'yes' ? true : false) 
      && singleItems 
      && singleItems?.[flag_name] == 'Y' 
      && singleItems?.['decomm_date']
      && payload[find_filter_key]
      && res 
      && res?.length==0) {
        return payload[find_filter_key] + ' ' + 'was decomissioned in' + ' Q'+ moment(singleItems['decomm_date']).quarter() + ' ' + moment(singleItems['decomm_date']).year()
    } else {
      return '';
    }
  }

}